import { HarmonyThemeType } from '../model/harmonyThemeData';
import { OfficeThemeMode } from '../model/officeStartTheme';
export var M365ThemeColorLight = '#FAFAFA';
export var M365ThemeColorDark = '#1F1F1F';
/**
 * Default fluent harmony themes
 */
export var HarmonyDefaultThemes = {
    Legacy: {
        id: 'harmonyLegacy',
        type: HarmonyThemeType.Harmony,
        mode: OfficeThemeMode.default,
        colorOverrides: {
            token: true,
        },
        colors: {
            NavBar: '#F0F0F0',
            Accent: '#D83B01',
            AppName: '#D83B01',
            DefaultText: '#242424',
            HoverText: '#242424',
            HoverBackground: '#FAFAFA',
            PressedText: '#242424',
            PressedBackground: '#F5F5F5',
            SelectedText: '#242424',
            SelectedBackground: '#F0F0F0',
            Darker: '#792000',
            Dark: '#A52C00',
            DarkAlt: '#C33400',
            Primary: '#D83B01',
            Secondary: '#DD4F1B',
            Tertiary: '#E8825D',
            Light: '#F4BEAA',
            Lighter: '#F9DCD1',
            LighterAlt: '#F9DCD1',
            DarkTheme: {
                NavBar: '#0A0A0A',
                Accent: '#FE7948',
                AppName: '#FE7948',
                DefaultText: '#FFFFFF',
                HoverText: '#FFFFFF',
                DefaultBackground: '#0A0A0A',
                HoverBackground: '#1F1F1F',
                PressedText: '#FFFFFF',
                PressedBackground: '#000000',
                SelectedText: '#FFFFFF',
                SelectedBackground: '#0A0A0A',
                Darker: '#FFB498',
                Dark: '#FF9973',
                DarkAlt: '#FF865A',
                Primary: '#FE7948',
                Secondary: '#E06A3F',
                Tertiary: '#99482B',
                Light: '#4D2415',
                Lighter: '#29130B',
                LighterAlt: '#29130B', // Office Dark Tint 40
            },
        },
    },
    Default: {
        id: 'harmony',
        type: HarmonyThemeType.Harmony,
        mode: OfficeThemeMode.default,
        colorOverrides: {
            token: true,
        },
        colors: {
            NavBar: '#F0F0F0',
            Accent: '#464FEB',
            AppName: '#464FEB',
            DefaultText: '#616161',
            HoverText: '#F0F0F0',
            HoverBackground: '#464FEB',
            PressedText: '#F0F0F0',
            PressedBackground: '#464FEB',
            SelectedText: '#F0F0F0',
            SelectedBackground: '#464FEB',
            Darker: '#27265C',
            Dark: '#353696',
            DarkAlt: '#3B3FB2',
            Primary: '#464FEB',
            Secondary: '#515EF5',
            Tertiary: '#B0BEFF',
            Light: '#CCD6FF',
            Lighter: '#E0E7FF',
            LighterAlt: '#E0E7FF',
            DarkTheme: {
                NavBar: '#0A0A0A',
                Accent: '#7385FF',
                AppName: '#7385FF',
                DefaultText: '#FFFFFF',
                HoverText: '#FFFFFF',
                DefaultBackground: '#0A0A0A',
                HoverBackground: '#7385FF',
                PressedText: '#FFFFFF',
                PressedBackground: '#7385FF',
                SelectedText: '#FFFFFF',
                SelectedBackground: '#7385FF',
                Darker: '#CCD6FF',
                Dark: '#96A6FF',
                DarkAlt: '#8295FF',
                Primary: '#7385FF',
                Secondary: '#3E45C9',
                Tertiary: '#2E2E78',
                Light: '#1E1D40',
                Lighter: '#16152B',
                LighterAlt: '#16152B', // Brand 10
            },
        },
    },
};
//# sourceMappingURL=harmony.js.map